import React from 'react'

const Contact = () => {
  return (
    <div>
      Contact US
    </div>
  )
}

export default Contact

